import type { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import type { TopUpFormData } from '../../TopUp';
import RadioSelect from '5-react-form-apps/FormComponents/RadioSelect/RadioSelect';
import HTMLReactParser from 'html-react-parser';

interface MethodOptionsProps {
    topUpViaCreditCardTitle?: string;
    topUpViaCreditCardDescription?: string;
    topUpViaBankTransferTitle?: string;
    topUpViaBankTransferDescription?: string;
    bankTransferDetailsRows?: {
        rowName: string;
        rowValue: string;
    }[];
}

const MethodOptions: FC<MethodOptionsProps> = ({ topUpViaBankTransferDescription, topUpViaBankTransferTitle, topUpViaCreditCardDescription, topUpViaCreditCardTitle, bankTransferDetailsRows }) => {
    const { control, reset, getValues } = useFormContext<TopUpFormData>();

    return (
        <Controller
            control={control}
            name="topUpType"
            rules={{ required: false }}
            render={({ field }): JSX.Element => {
                return (
                    <div className="top-up-radio-select-wrapper">
                        <RadioSelect
                            groupTitle="Top up via"
                            name="top-up-via"
                            value={field.value}
                            onChange={(value): void => {
                                field.onChange(value);
                                reset({ ...getValues(), amount: undefined, otherAmount: undefined });
                            }}
                        >
                            <RadioSelect.Item
                                value="credit-card"
                                label={topUpViaCreditCardTitle || ''}
                                message={
                                    <div className="top-up-radio-select-message-wrapper">
                                        {HTMLReactParser(topUpViaCreditCardDescription || '')}
                                    </div>
                                }
                            />
                            <RadioSelect.Item
                                value="bank-transfer"
                                label={topUpViaBankTransferTitle || ''}
                                message={
                                    <div className="top-up-radio-select-message-wrapper">
                                        <div className="top-up-radio-select-message-description">
                                            {HTMLReactParser(topUpViaBankTransferDescription || '')}
                                        </div>
                                        {bankTransferDetailsRows && (
                                            <div>
                                                {bankTransferDetailsRows.map((row, index) => {
                                                    return (
                                                        <div
                                                            key={`top-up-radio-select-message-table-row-item-${index + 1}`}
                                                            className="top-up-radio-select-message-table-row"
                                                        >
                                                            <span className="top-up-radio-select-message-table-item-bold">{row.rowName}</span>
                                                            <span className="top-up-radio-select-message-table-item">{row.rowValue}</span>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </div>
                                }
                            />
                        </RadioSelect>
                    </div>
                );
            }}
        />
    );
};

export default MethodOptions;
